module.exports = __webpack_public_path__ + "img/roleNurse.d0fd0768.svg";